import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { LeaveAdjustment } from '../ILeaveAdjustment';
import * as LeaveAdjustmentActions from './leave-adjustment.actions';

export const leaveAdjustmentsFeatureKey = 'leaveAdjustments';

export interface State extends EntityState<LeaveAdjustment> {
    // additional entities state properties
}

export const adapter: EntityAdapter<LeaveAdjustment> =
    createEntityAdapter<LeaveAdjustment>({
        selectId: (model: LeaveAdjustment) => model.Uniqueid
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const leaveAdjustmentReducer = createReducer(
    initialState,
    on(LeaveAdjustmentActions.addLeaveAdjustment, (state, action) =>
        adapter.addOne(action.leaveAdjustment, state)
    ),
    on(LeaveAdjustmentActions.upsertLeaveAdjustment, (state, action) =>
        adapter.upsertOne(action.leaveAdjustment, state)
    ),
    on(LeaveAdjustmentActions.addLeaveAdjustments, (state, action) =>
        adapter.addMany(action.leaveAdjustments, state)
    ),
    on(LeaveAdjustmentActions.upsertLeaveAdjustments, (state, action) =>
        adapter.upsertMany(action.leaveAdjustments, state)
    ),
    on(LeaveAdjustmentActions.updateLeaveAdjustment, (state, action) =>
        adapter.updateOne(action.leaveAdjustment, state)
    ),
    on(LeaveAdjustmentActions.updateLeaveAdjustments, (state, action) =>
        adapter.updateMany(action.leaveAdjustments, state)
    ),
    on(LeaveAdjustmentActions.deleteLeaveAdjustment, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(LeaveAdjustmentActions.deleteLeaveAdjustments, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(LeaveAdjustmentActions.loadLeaveAdjustments, (state, action) =>
        adapter.setAll(action.leaveAdjustments, state)
    ),
    on(LeaveAdjustmentActions.clearLeaveAdjustments, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return leaveAdjustmentReducer(state, action);
}

export const selectLeaveAdjustmentState = createFeatureSelector<State>(
    leaveAdjustmentsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectLeaveAdjustmentState);
